
<!--
 * @Author: shiao
 * @LastEditors: shiao
 * @FilePath: \o2o-app\src\app.vue
-->


<template>
  <div id="app" style="height: 100%">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { getQuery } from "./pages/groupBuy/utils";

export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
  created() {
    const token = getQuery("token");
    if (token) {
      this.$api.setToken(decodeURIComponent(token));
    }
  },
  mounted() {},
};
</script>


<style lang="less" scoped>

#app {
  height: 100%;
}
</style>

